module.exports = __WEBPACK_EXTERNAL_MODULE_https_frwidget_demo_test_kravata_co_remoteEntry_js_e46b7331__;